import React, { useEffect } from 'react';
import './App.css';

function Servicio() {
  useEffect(() => { document.title = 'Servicios'; }, []);
  return (
    <div>
      <section className="second-section-padding">
        <div className="container-fluid ps-md-5 pb-5 pt-5">
          <div className="row align-items-center ps-lg-5 ps-md-3">
            {/* Columna de texto */}
            <div className="col-lg-8 col-md-6 pe-md-5 px-5 pt-5">
              <h1 className="title2 graytitle2 text-start">
                Lo que Nos
              </h1>
              <h1 className="title2 redtitle2 text-start">
                Hace Únicos
              </h1>
              <p className="txt2">
                <span style={{color: 'var(--first-color)', fontWeight:'bold', textTransform:'uppercase'}}>Óptica París </span>es la evolución de una tradición que se ha consolidado a lo largo de décadas. Juntos, seguiremos creciendo, innovando y ofreciendo lo mejor de nosotros mismos, porque en OPV Óptica, tu visión es nuestra prioridad.
              </p>
            </div>
            {/* Columna de imagen */}
            <div className="col-lg-4 col-md-6 text-end p-md-0 ps-sm-5 pe-0">
              <img src={process.env.PUBLIC_URL + '/servicios/foto.webp'} alt="Servicios" className="img-fluid rounded-circle nosotros-img-futuro"  />
            </div>
          </div>
        </div>
      </section>
      <section className="second-section-padding section-bottom-border">
        <div className="container py-5">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
            {[...Array(6)].map((_, idx) => (
              <div className="col" key={idx}>
                <div className="card h-100 shadow-sm border-0">
                  <img src={process.env.PUBLIC_URL + (idx === 5 ? '/servicios/Stellest.png' : idx === 4 ? '/servicios/ZEISS.png' : idx === 1 ? '/servicios/movil.png' : idx === 3 ? '/servicios/CONVENIOS.webp': idx === 2 ? '/servicios/MANTENIMIENTO.png' : '/servicios/examen.webp')} className="card-img-top" alt={idx === 4 ? 'Tecnología para ralentizar miopía' : idx === 3 ? 'Tecnología Zeiss' : idx === 2 ? 'Convenios con empresas' : idx === 1 ? 'Mantenimiento de calidad' : 'Examen de la vista'} />
                  <div className="card-body p-lg-4 p-md-3">
                    {idx === 0 ? (
                      <>
                        <h5 className="card-title text-start" style={{color: 'var(--first-color)', fontFamily:'Work Sans', fontWeight: '800', textTransform: 'uppercase'}}>EXAMEN DE LA VISTA</h5>
                        <p className="card-text txt2 servicio-card-text">
                          Realiza el examen en cualquiera de nuestras sucursales, incluye toma de la presión intraocular, es completamente gratis.
                        </p>
                      </>
                    ) : idx === 2 ? (
                      <>
                        <h5 className="card-title text-start" style={{color: 'var(--first-color)' , fontFamily:'Work Sans', fontWeight: '800', textTransform: 'uppercase'}}>MANTENIMIENTO DE CALIDAD</h5>
                        <p className="card-text txt2 servicio-card-text">
                          Las gafas son artículos de uso constante, es por eso que es importante llevarlos a revisión, ajustes y limpieza por lo menos cada dos o tres meses. Es gratis, acude a nuestras tiendas.
                        </p>
                      </>
                    ) : idx === 1 ? (
                      <>
                        <h5 className="card-title text-start" style={{color: 'var(--first-color)', fontWeight: '800' , fontFamily:'Work Sans', textTransform: 'uppercase'}}>ÓPTICA MÓVIL</h5>
                        <p className="card-text txt2 servicio-card-text">
                          Ponemos a tu disposición los avances de la óptica a las puertas de tu Empresa u Oficina.
                        </p>
                      </>
                    ) : idx === 3 ? (
                      <>
                        <h5 className="card-title text-start" style={{color: 'var(--first-color)' , fontFamily:'Work Sans', fontWeight: '800', textTransform: 'uppercase'}}>CONVENIOS CON EMPRESAS</h5>
                        <p className="card-text txt2 servicio-card-text">
                          Tenemos relación con las empresas más importantes del Estado de Veracruz para que tu vista no sea un problema. No dudes en llamarnos para que un representante te visite.
                        </p>
                      </>
                    ) : idx === 4 ? (
                      <>
                        <h5 className="card-title text-start" style={{color: 'var(--first-color)' , fontFamily:'Work Sans', fontWeight: '800', textTransform: 'uppercase'}}>TECNOLOGÍA ZEISS</h5>
                        <div className="card-text txt2 servicio-card-text">
                          <p>Contamos con la mejor tecnología para tu vista.</p>                          
                          <ul style={{paddingLeft: '1.7em', marginBottom: 0}}>
                            <li style={{fontSize:'1rem'}}><p>UV Protect para cuidar tus ojos del sol.</p></li>
                            <li style={{fontSize:'1rem'}}><p>Progresivo Precision Pro visión clara y dinámica en medios digitales.</p></li>
                            <li style={{fontSize:'1rem'}}><p>OfficeLens en lo mejor para tu visión en el trabajo.</p></li>
                            <li style={{fontSize:'1rem'}}><p>Progresivo Precision SuperB con tecnología FaceFit+</p></li>
                            <li style={{fontSize:'1rem'}}><p>Duravision BlueProtect UV protege y filtra selectivamente la luz ultra-violeta.</p></li>
                            <li style={{fontSize:'1rem'}}><p>Photofusion se oscurecen y aclaran mucho más rápido que otros fotosensibles.</p></li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      <>
                        <h5 className="card-title text-start" style={{color: 'var(--first-color)', paddingBottom: '1.5%' , fontFamily:'Work Sans', fontWeight: '800', textTransform: 'uppercase'}}>TECNOLOGÍA PARA RALENTIZAR MIOPÍA</h5>
                        <p className="card-text txt2 servicio-card-text">
                          La lente oftálmica <strong>Stellest</strong> utiliza la tecnología <strong>HALT</strong>, basada en microlentes que crean un desenfoque miópico periférico para frenar el alargamiento axial del ojo y, así, ralentizar la progresión de la miopía. A la vez, mantiene una visión central clara, garantizando buena calidad visual en el uso diario.
                        </p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Servicio; 